// extracted by mini-css-extract-plugin
export var companyName = "index-module--companyName--deb54";
export var copy = "index-module--copy--bd362";
export var ctaButtonContainer = "index-module--ctaButtonContainer--4ebda";
export var navItem = "index-module--navItem--dfe7c";
export var navList = "index-module--navList--44ba9";
export var root = "index-module--root--ff084";